<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.4 15.4L6 14l6-6 6 6-1.4 1.4-4.6-4.6-4.6 4.6z"/></svg>